module.exports = "<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"card bottom-margin-0\">\n      <div class=\"card-header card-header-icon\" data-background-color=\"green\">\n        <i class=\"material-icons\">tune</i>\n      </div>\n      <div class=\"card-content\">\n        <div class=\"col-md-8\" style=\"padding-left: 0px\">\n          <h4 class=\"card-title\">Confident Models</h4>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/cmodel/cmodel.html
// module id = 1367
// module chunks = 0